import { getAxiosBackendApi1 } from "../helpers/axios"

class BankLoansServices{

    constructor(){
    }

    addInjured(data){
        return getAxiosBackendApi1().post('woundeds', data)
    }

    addMartyr(data){
        return getAxiosBackendApi1().post('martyrs', data)
    }
}

export default new BankLoansServices()